import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import SiteSidebar from './SiteSidebar';
import { icon } from './ui';
const ERRORS = {
  access_denied: 'Anulowano zgodę na połączenie konta Discord.',
  invalid_oauth_state: 'Sesja łączenia wygasła. Rozpocznij łączenie ponownie.',
  discord_already_linked: 'To konto Discord jest już połączone z innym kontem NovaID.',
  discord_api_error: 'Discord chwilowo nie potwierdził połączenia. Spróbuj ponownie za moment.',
  missing_oauth_data: 'Discord nie przekazał kompletnych danych autoryzacji.'
};
export default class DiscordResultPage extends Page {
  success = false;
  code = '';
  oninit(vnode) {
    super.oninit(vnode);
    this.success = String(m.route.get()).includes('/polaczono');
    this.code = String(m.route.param('code') || '');
  }
  oncreate() {
    window.scrollTo(0, 0);
  }
  view() {
    const title = this.success ? 'Konto Discord połączone' : 'Nie udało się połączyć konta';
    const message = this.success ? 'Discord został bezpiecznie przypisany do Twojego NovaID. Nick i role zostaną zsynchronizowane automatycznie.' : ERRORS[this.code] || 'Wystąpił błąd podczas łączenia konta Discord. Możesz bezpiecznie spróbować ponownie.';
    return m("div", {
      className: "NtDiscordResultPage"
    }, m("div", {
      className: "container NtSubpageLayout"
    }, m(SiteSidebar, null), m("main", null, m("section", {
      className: `NtDiscordResult ${this.success ? 'is-success' : 'is-error'}`
    }, m("span", {
      className: "NtDiscordResult-icon"
    }, icon(this.success ? 'fas fa-check' : 'fas fa-exclamation-triangle')), m("small", null, "NOVA ID \u2022 DISCORD"), m("h1", null, title), m("p", null, message), !this.success && this.code ? m("code", {
      className: "NtDiscordResult-code"
    }, "Kod b\u0142\u0119du: ", this.code) : null, m("div", null, m(Link, {
      className: "Button Button--primary",
      href: "/novaid"
    }, icon('fas fa-id-card'), " WR\xD3\u0106 DO NOVAID"), m(Link, {
      className: "Button",
      href: app.route('index')
    }, icon('fas fa-comments'), " PRZEJD\u0179 NA FORUM"), !this.success ? m(Link, {
      className: "Button",
      href: "/t/pomoc-techniczna"
    }, icon('fas fa-life-ring'), " ZG\u0141O\u015A PROBLEM ADMINISTRACJI") : null)))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/DiscordResultPage', DiscordResultPage);